module.exports = __webpack_public_path__ + "img/matchday.ab5951b1.png";